// import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import React, { useEffect, useState } from "react";
import { Title } from "react-admin";
import { makeStyles } from '@material-ui/core/styles';
import MaterialLink from '@material-ui/core/Link';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
// import NextLink from '../common/NextLink';
import { Button } from '@material-ui/core';
import Moment from 'react-moment';
import {Link, useParams} from 'react-router-dom';
import { fetchMmgrApi } from "./api";

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
});

export const Library = () => {
    const classes = useStyles();
    let { id } = useParams();

    const [data, setData] = useState();

    useEffect(() => {
        if(id){
            fetchMmgrApi('get', '/library/'+id+'/messages').then(v => {
                setData(v);
            });
        }
    }, [id]);

    if(!data){
        return <div>Loading...</div>;
    }

    return <Container>
    <Box my={2}>
        <Breadcrumbs aria-label="breadcrumb">
            <Link color="inherit" to="/executions">
                Message Libraries
            </Link>
            <Typography color="textPrimary">Library: {id}</Typography>
        </Breadcrumbs>
    </Box>

    <Box my={2}>
        <Typography component="h1" variant="h6" color="inherit" noWrap>
            Message Bundle
        </Typography>
        <Typography>
            This message bundle was generated from the GTFS bundle published <Moment format="DD MMM YYYY, HH:mm">{data.meta.BundleData.headers["last-modified"]}</Moment> (<Moment fromNow>{data.meta.BundleData.headers["last-modified"]}</Moment>)
        </Typography>
        <Typography>
            <MaterialLink href={data.s3Url}>
                Download message_library_opendata.zip
            </MaterialLink>
        </Typography>
    </Box>

    <Box my={2}>
        <Typography component="h1" variant="h6" color="inherit" noWrap>
            Messages ({data.messages.length})
        </Typography>
        <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell>Message ID</TableCell>
                        <TableCell>Message</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.messages.map((row) => (
                        <TableRow key={row.message_id}>
                            <TableCell component="th">
                                <Link to={`/library/${encodeURIComponent(id ? id.toString() : 'unknown')}/message/${encodeURIComponent(row.message_id)}`}>{row.message_id}</Link>
                            </TableCell>

                            <TableCell scope="row">
                                {row.text_message}
                            </TableCell>

                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    </Box>
</Container>
};
